import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';

import { GA_HEADER_HOME_ACTION } from '../../../../containers/home/domain/store/HomeStoreEn';
import { useCitySelectedContext } from '../../../../contexts/city-context/CityContext';
import NextImageV2 from '../../../../ui/components/NextImageV2';
import { oms_url } from '../../../config/AppConfig';
import * as LocaleConstants from '../../../constants/LocaleConstants';
import { CommonImage } from '../../../types/CommonVM';
import {
  ban_home_link,
  desktop_logo_height,
  desktop_logo_width,
  mobile_logo_height,
  mobile_logo_width,
  tur_home_link,
} from '../vm/HeaderStore';

interface LogoComponentProps {
  logo: CommonImage;
  isDesktop: boolean;
}

function redirectionLink(locale?: string): string {
  switch (locale) {
    case LocaleConstants.bn_BD:
    case LocaleConstants.en_BD:
      return ban_home_link;
    case LocaleConstants.en_TR:
    case LocaleConstants.en_TK:
    case LocaleConstants.tr_TR:
      return tur_home_link;
    case LocaleConstants.en_AE:
    case LocaleConstants.en_IN:
      return oms_url;
    default:
      return '/';
  }
}

function LogoComponent({
  logo,
  isDesktop,
}: Readonly<LogoComponentProps>): React.ReactElement {
  const { locale } = useRouter();
  const citySelectedContext = useCitySelectedContext();

  return (
    <Link
      href={redirectionLink(locale) + citySelectedContext.query_params}
      onClick={(): void =>
        publishGa4Events(citySelectedContext.category, GA_HEADER_HOME_ACTION)
      }
    >
      <NextImageV2
        src={logo.path}
        alt={logo.alt_text}
        height={isDesktop ? desktop_logo_height : mobile_logo_height}
        width={isDesktop ? desktop_logo_width : mobile_logo_width}
        quality={100}
      />
    </Link>
  );
}

export default LogoComponent;
